import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { injectIntl, IntlShape } from 'react-intl';
import { useSelector } from 'react-redux';
import { isNil, get, isEmpty } from 'lodash';
import LegalProceedingTabs from 'components/LegalProceedingTabs';
import { isBlockStatusClaim } from 'containers/CourtManagerLegalProceedings/utils';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { renderSearchQuery } from 'containers/ExpertAssignedMissionShow/utils';
import { PAGES } from 'routes';
import routesHelper from 'containers/services/routes-helper';
import NoticeDeficiency from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/NoticeDeficiency';
import { expertiseExpertTabsLabels } from 'containers/CourtManagerLegalProceedings/constants';
import ExpertReport from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/ExpertReport';
import {
  makeSelectMissionPostPonse,
  makeSelectMissionPostPonseExpertise,
  makeSelectVictimExpertise,
} from 'containers/ExpertExpertise/selectors';
import PostPoneExpertise from 'containers/CourtManagerLegalProceedings/ExpertiseExpert/PostPoneExpertise';
import { makeSelectFeeNotes } from 'containers/LawyerFeeNote/selectors';
import { STATUS_VALIDATED } from 'containers/LawyerFeeNote/constants';
import { priorityClaimReason } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { resolveSagisClaim } from 'helpers/utils';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { ClaimRecapType } from 'typings/claimTypes';
import { OPENING_STATE } from 'services/constants';

export interface ExpertiseExpertProps {
  intl: IntlShape;
  match: { params: { claimId: number } };
  requestMakeDecisionMissionExpertise: Function;
  requestMakeDecisionMissionNoticeDeficiency: Function;
  isLawyer?: boolean;
  claimNumber: string;
  requestFeeNotesByClaimNumb: Function;
  onPressFeeNote: () => void;
  currentTabManagerExpertise: any;
  riskKey: string;
  setOpenFeeNoteDialog: Function;
  claimRecap: ClaimRecapType;
  resetSearchClaimsStore: Function;
  resetStoreClaim: Function;
  resetSagisInfoClaim: Function;
  resetLegalProceeding: Function;
  policyInfo: any;
  currentIndexTabManager: any;
  currentInstanceTabIndexManager: any;
  currentTabInstance: any;
  requestSearchClaims: any;
  listings: any;
  requestSetPriorityClaimProvision?: Function;
  requestGetDocByDocumentumId: Function;
  requestGetExpertiseVictim: Function;
}
const ExpertiseExpert: React.FC<ExpertiseExpertProps> = (
  props,
): JSX.Element => {
  const expertiseVictim: any = useSelector(makeSelectVictimExpertise());
  const missionPostPone: any = useSelector(makeSelectMissionPostPonse());
  const missionPostPoneExpertise: any = useSelector(
    makeSelectMissionPostPonseExpertise(),
  );
  const claimId = props.match.params.claimId;
  const feeNotes = useSelector(makeSelectFeeNotes());
  useEffect(() => {
    if (!props.isLawyer) {
      props.requestFeeNotesByClaimNumb(props.claimNumber);
    }
  }, [props.claimNumber]);

  useEffect(() => {
    props.resetSearchClaimsStore();
    if (
      !isEmpty(props.claimRecap) &&
      !isNil(get(props.claimRecap, 'claim.claimNumber', null))
    ) {
      const searchQuery = renderSearchQuery(props.claimRecap);
      props.requestSearchClaims(searchQuery);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.claimRecap,
    props.currentIndexTabManager,
    props.currentInstanceTabIndexManager,
    props.currentTabInstance,
  ]);

  useEffect(() => {
    if (claimId) {
      props.requestGetExpertiseVictim({
        missionId: null,
        claimId,
        missionVictimId: null,
        missionVehicleId: null,
        isIntervenant: currentIntervenantStorage.get() ? true : false,
        isLegalProceeding: false,
      });
    }
  }, [!claimId]);
  useEffect(() => {
    if (
      (!isEmpty(props.claimRecap) &&
        !props.isLawyer &&
        (get(props.claimRecap, 'claim.status') !== STATUS_VALIDATED ||
          get(props, 'claimRecap.claim.openingState') !=
            OPENING_STATE.COMPLETED)) ||
      (!isEmpty(get(props.policyInfo, 'sagis', {})) &&
        !props.isLawyer &&
        isBlockStatusClaim(props.policyInfo))
    ) {
      props.resetSearchClaimsStore();
      props.resetStoreClaim();
      props.resetSagisInfoClaim();
      props.resetLegalProceeding();
      routesHelper.pushTo(
        `${PAGES.CONSULTATION_LEGAL_PROCEEDING_PAGE}/${get(props, [
          'match',
          'params',
          'claimId',
        ])}`,
      )();
    }
  }, [
    props.policyInfo,
    props.claimRecap,
    props.currentIndexTabManager,
    props.currentInstanceTabIndexManager,
    props.currentTabInstance,
  ]);
  useEffect(() => {
    if (
      !isEmpty(get(props.policyInfo, 'sagis', [])) &&
      featureService.hasFeature(FEATURES.PRIORITY_CLAIM) &&
      (isNil(get(props.claimRecap, 'claim.priorityReasonId', null)) ||
        get(props.claimRecap, 'claim.priorityReasonId', null) != 4)
    ) {
      const priorityReason = priorityClaimReason(
        [],
        !isEmpty(get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []))
          ? get(resolveSagisClaim(props.policyInfo), 'offeredRisks', [])
              .map((el: any) => Number(el.riskProvisions))
              .reduce(
                (accumulator: any, currentValue: any) =>
                  accumulator + currentValue,
              )
          : 0,
        props.listings,
      );
      if (priorityReason && props.requestSetPriorityClaimProvision) {
        props.requestSetPriorityClaimProvision({
          id: Number(props.match.params.claimId),
          claimInfo: { priorityReasonId: priorityReason },
          username: currentUserStorage.get().username,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
        });
      }
    }
  }, [props.policyInfo]);
  return (
    <LegalProceedingTabs
      labels={expertiseExpertTabsLabels}
      currentTabIndex={
        isNil(props.currentTabManagerExpertise)
          ? 0
          : props.currentTabManagerExpertise
      }
      onPressFeeNote={props.onPressFeeNote}
    >
      <ExpertReport
        expertisesVictim={expertiseVictim}
        requestMakeDecisionMissionExpertise={
          props.requestMakeDecisionMissionExpertise
        }
        claimId={claimId}
        isLawyer={props.isLawyer}
        feeNotes={feeNotes}
        claimNumber={props.claimNumber}
        riskKey={props.riskKey}
        setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
        requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
      />
      <Grid item xs={12}>
        <NoticeDeficiency
          missionPostPone={missionPostPone}
          requestMakeDecisionMissionNoticeDeficiency={
            props.requestMakeDecisionMissionNoticeDeficiency
          }
          claimId={claimId}
          isLawyer={props.isLawyer}
          feeNotes={feeNotes}
          missionPostPoneExpertise={missionPostPoneExpertise}
          claimNumber={props.claimNumber}
          setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      </Grid>
      <Grid item xs={12}>
        <PostPoneExpertise
          missionPostPoneExpertise={missionPostPoneExpertise}
          requestMakeDecisionMissionNoticeDeficiency={
            props.requestMakeDecisionMissionNoticeDeficiency
          }
          claimId={claimId}
          isLawyer={props.isLawyer}
          claimNumber={props.claimNumber}
          setOpenFeeNoteDialog={props.setOpenFeeNoteDialog}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      </Grid>
    </LegalProceedingTabs>
  );
};
export default injectIntl(ExpertiseExpert);
